export default __webpack_public_path__ + "static/media/sunglasses.c2e7dfa6.jpg";